import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Company } from '../company.model';
import { SessionStorageService } from '../../services/session-storage.service';
import { PartyQuickCreateDialogComponent, PartyQuickCreateResult } from '../../shared/party-quick-create/party-quick-create-dialog.component';

@Component({
    selector: 'app-company-form',
    templateUrl: './company-form.component.html',
    styleUrls: ['./company-form.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        PartyQuickCreateDialogComponent
    ]
})
export class CompanyFormComponent {
    @Input() displayModal = false;
    @Input() dialogHeader = '';
    @Input() submitButtonLabel = '';
    @Input() company: Company = new Company();
    @Output() modalClosed = new EventEmitter<Company | boolean>();

    private completedThisCycle = false;

    constructor(private readonly sessionStorageService: SessionStorageService) {}

    get owningCompany(): Company | null {
        return this.sessionStorageService.getCompany() ?? null;
    }

    get countries() {
        return this.sessionStorageService.getCountryList() ?? [];
    }

    onDialogCompleted(result: PartyQuickCreateResult): void {
        this.completedThisCycle = true;
        this.modalClosed.emit(result.record as Company);
    }

    onVisibilityChanged(visible: boolean): void {
        this.displayModal = visible;
        if (!visible && !this.completedThisCycle) {
            this.modalClosed.emit(false);
        }
        if (visible) {
            this.completedThisCycle = false;
        }
    }

    onDialogFailed(): void {
        this.completedThisCycle = false;
    }
}
